module.exports = __webpack_public_path__ + "static/media/icon-total-0.ed5f1cde.svg";